// extracted by mini-css-extract-plugin
export default {"wrapper":"Support_wrapper__IjNci","sidebarWrapper":"Support_sidebarWrapper__Gy689","sectionWrapper":"Support_sectionWrapper__qRb0+"};